import Accordion from 'react-bootstrap/Accordion';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_ITEMS = [
  { q: 'faqQuestion1', a: 'faqAnswer1' },
  { q: 'faqQuestion2', a: 'faqAnswer2' },
  { q: 'faqQuestion3', a: 'faqAnswer3' },
];

const FAQSection = ({ items = DEFAULT_ITEMS }) => {
  const { t } = useTranslation();

  return (
    <div className="accordion row ">
      <div className="col-sm-12">
        <Accordion defaultActiveKey="0">
          {items.map((it, i) => (
            <Accordion.Item eventKey={String(i)} key={i}>
              <Accordion.Header>{t(it.q)}</Accordion.Header>
              <Accordion.Body>{t(it.a)}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FAQSection;
